import React, { useCallback, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material'

import Protected from 'admin/components/protected'
import Setting from 'admin/components/setting'
import CustomizedDialogTitle from 'admin/components/dialog-title'
import TextField from 'admin/components/textfield'
import { useApiRequest, useStores } from 'admin/hooks'
import * as srv from 'admin/services'

const RespondIoSetting = () => {
  const { respondIoSettingStore, notificationStore } = useStores()
  const [channelId, setChannelId] = useState('')

  const { request: updateSetting, isLoading: updateProcessing } = useApiRequest(
    srv.updateRespondIoSetting,
    { blocking: true },
  )

  useEffect(() => {
    setChannelId(respondIoSettingStore.setting.whatsappChannelId || '')
  }, [respondIoSettingStore.setting.whatsappChannelId])

  const handleOpen = () => {
    setChannelId(respondIoSettingStore.setting.whatsappChannelId || '')
    respondIoSettingStore.setOpenDialog(true)
  }

  const handleClose = () => {
    respondIoSettingStore.setOpenDialog(false)
  }

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault()
      if (updateProcessing) return

      const response = await updateSetting({
        whatsappChannelId: channelId,
      })
      if (!response) return

      notificationStore.setSuccess('Update WhatsApp channel ID success')
      respondIoSettingStore.setOpenDialog(false)
      respondIoSettingStore.fetch()
    },
    [channelId, updateProcessing],
  )

  return (
    <Setting
      title="WhatsApp (Respond.io)"
      action={
        <Protected
          level="update"
          category="setting"
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={handleOpen}
          >
            Edit
          </Button>
          <Dialog
            open={respondIoSettingStore.openDialog}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
          >
            <CustomizedDialogTitle onClose={handleClose}>WhatsApp Channel ID</CustomizedDialogTitle>
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <TextField
                  fullWidth
                  name="whatsappChannelId"
                  label="Channel ID"
                  color="secondary"
                  value={channelId}
                  onChange={(event) => setChannelId(event.target.value)}
                  size="small"
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  color="secondary"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="secondary"
                  disabled={updateProcessing}
                >
                  Save
                </Button>
              </DialogActions>
            </form>
          </Dialog>
        </Protected>
      }
      table={
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell>Channel ID</TableCell>
              <TableCell align="right">
                {respondIoSettingStore.setting.whatsappChannelId || '-'}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      }
    />
  )
}

export default observer(RespondIoSetting)
